export function validateRequired(value) {
	return !value;
}

export function validateMinStringLength(value, rule) {
	return value && value.length < rule;
}

export function validateMaxStringLength(value, rule) {
	return value && value.length > rule;
}

export function validateEmail(value) {
	if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
		return true;
	}

	return false;
}

export function validateHtmlWithWhitelist(input) {
	const regexPattern = /<\/?(b|u|i|strong|h[1-6]|p|ol|ul|li|a|img|br|span|div|figure|svg|path)(\s[^>]*)?>|[^<]+/g;

	const sanitizedInput = input.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(regexPattern, '');

	return sanitizedInput.trim().indexOf('<') !== -1;
}

export function validateDropdownOptionsMin(options, rule) {
	return options.length < rule;
}

export function validateDropdownOptionRequired(option) {
	return !option;
}

export function validateLink(link) {
	let url;

	try {
		url = new URL(link);
	} catch (_) {
		return false;
	}

	return url;
}

export function verifyLength(authorName) {
	let errors = [];

	if (!authorName || authorName.trim() === "") {
		errors.push("This field is required.");
	}

	if (authorName.length >= 256) {
		errors.push("This field should not have more than 255 characters.");
	}

	return errors;
}

/**
 * @param input should be a String (simple text)
 * @param validations is an Object that has min and max values (Integers)
 * @returns {*[]} array with errors - each error is just a String
 */
export function validateInput(input, validations) {
	const errors = [];

	if(typeof input === 'number') {
		if((validations.min && input < validations.min) || (validations.max && input > validations.max)) {
			errors.unshift({name: `notValidLength`, min: validations.min, max: validations.max})
		}
	}else if(typeof input === 'string') {
		if (input.trim() === '' && validations.required) {
			errors.unshift({name: 'notEmpty'})
		}

		if (input.trim() !== '' && ((validations.min && validations.min > input.length) || (validations.max && validations.max < input.length))) {
			errors.unshift({name: `notValidLength`, min: validations.min, max: validations.max})
		}

		if (input && validations.checkUrl) {
			isValidUrl(errors, input);
		}

		if (input && validations.checkEmail) {
			isValidEmail(errors, input);
		}
	}else if(typeof input === 'undefined') {
		if(validations.required){
			errors.unshift({name: 'notEmpty'})
			return errors;
		}
		if(validations.min){
			errors.unshift({name: `notValidLength`, min: validations.min, max: validations.max})
			return errors;
		}
		if(validations.checkUrl) {
			isValidUrl(errors, input);
			return errors;
		}
		if(validations.checkEmail) {
			isValidEmail(errors, input);
			return errors;
		}
	}

	return errors;
}

function isValidUrl(errors, input) {
	const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
	const isValid = urlRegex.test(input);

	if (!isValid && typeof input === 'string' && input.trim() !== ''){
		errors.unshift({name: 'notValidUrl'})
	}
}

function isValidEmail(errors, input) {
	const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
	const isValid = emailRegex.test(input);

	if (!isValid) {
		errors.unshift({name: 'notValidEmail'})
	}
}
